import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'
import { InitialState } from './types'

const initialState: InitialState = {
  blocks: [],
  modules: [],
  processIsFetching: false,
  processIsUpdateBlock: false,
  processIsSortBlocks: false,
  processIsDeleteBlock: false,
  processIsCreateBlock: false,
  processIsCreateSimpleTask: false,
  processIsFetchingModules: false,
  processIsUpdateSimpleTask: false,
  processIsFetchingSimpleTaskNotion: false,
  processIsFetchingNotion: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchLessonBlocks]: state => {
      return {
        ...state,
        processIsFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchLessonBlocksSuccess]: (state, action) => {
      return {
        ...state,
        blocks: action.result,
        processIsFetching: false,
      }
    },
    [actions.fetchLessonBlocksFailure]: (state, action) => {
      return {
        ...state,
        processIsFetching: false,
        error: action.error,
      }
    },
    [actions.updateBlock]: state => {
      return {
        ...state,
        processIsUpdateBlock: true,
        error: initialState.error,
      }
    },
    [actions.updateBlockSuccess]: state => {
      return {
        ...state,
        processIsUpdateBlock: false,
      }
    },
    [actions.updateBlockFailure]: (state, action) => {
      return {
        ...state,
        processIsUpdateBlock: false,
        error: action.error,
      }
    },
    [actions.sortBlocks]: state => {
      return {
        ...state,
        processIsSortBlocks: true,
        error: initialState.error,
      }
    },
    [actions.sortBlocksSuccess]: state => {
      return {
        ...state,
        processIsSortBlocks: false,
      }
    },
    [actions.sortBlocksFailure]: (state, action) => {
      return {
        ...state,
        processIsSortBlocks: false,
        error: action.error,
      }
    },
    [actions.deleteBlock]: state => {
      return {
        ...state,
        processIsDeleteBlock: true,
        error: initialState.error,
      }
    },
    [actions.deleteBlockSuccess]: state => {
      return {
        ...state,
        processIsDeleteBlock: false,
      }
    },
    [actions.deleteBlockFailure]: (state, action) => {
      return {
        ...state,
        processIsDeleteBlock: false,
        error: action.error,
      }
    },
    [actions.createBlock]: state => {
      return {
        ...state,
        processIsCreateBlock: true,
        error: initialState.error,
      }
    },
    [actions.createBlockSuccess]: state => {
      return {
        ...state,
        processIsCreateBlock: false,
      }
    },
    [actions.createBlockFailure]: (state, action) => {
      return {
        ...state,
        processIsCreateBlock: false,
        error: action.error,
      }
    },
    [actions.createSimpleTask]: state => {
      return {
        ...state,
        processIsCreateSimpleTask: true,
        error: initialState.error,
      }
    },
    [actions.createSimpleTaskSuccess]: state => {
      return {
        ...state,
        processIsCreateSimpleTask: false,
      }
    },
    [actions.createSimpleTaskFailure]: (state, action) => {
      return {
        ...state,
        processIsCreateSimpleTask: false,
        error: action.error,
      }
    },
    [actions.fetchModules]: state => {
      return {
        ...state,
        processIsFetchingModules: true,
        error: initialState.error,
      }
    },
    [actions.fetchModulesSuccess]: (state, action) => {
      return {
        ...state,
        modules: action.result,
        processIsFetchingModules: false,
      }
    },
    [actions.fetchModulesFailure]: (state, action) => {
      return {
        ...state,
        processIsFetchingModules: false,
        error: action.error,
      }
    },
    [actions.updateSimpleTask]: state => {
      return {
        ...state,
        processIsCreateSimpleTask: true,
        error: initialState.error,
      }
    },
    [actions.updateSimpleTaskSuccess]: state => {
      return {
        ...state,
        processIsCreateSimpleTask: false,
      }
    },
    [actions.updateSimpleTaskFailure]: (state, action) => {
      return {
        ...state,
        processIsCreateSimpleTask: false,
        error: action.error,
      }
    },
    [actions.fetchSimpleTaskNotion]: state => {
      return {
        ...state,
        processIsFetchingSimpleTaskNotion: true,
        error: initialState.error,
      }
    },
    [actions.fetchSimpleTaskNotionSuccess]: state => {
      return {
        ...state,
        processIsFetchingSimpleTaskNotion: false,
      }
    },
    [actions.fetchSimpleTaskNotionFailure]: (state, action) => {
      return {
        ...state,
        processIsFetchingSimpleTaskNotion: false,
        error: action.error,
      }
    },
    [actions.fetchNotion]: state => {
      return {
        ...state,
        processIsFetchingNotion: true,
        error: initialState.error,
      }
    },
    [actions.fetchNotionSuccess]: state => {
      return {
        ...state,
        processIsFetchingNotion: false,
      }
    },
    [actions.fetchNotionFailure]: (state, action) => {
      return {
        ...state,
        processIsFetchingNotion: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
